// API service for Yung World store
const API_URL = process.env.REACT_APP_BACKEND_URL;

// Generate or get session ID for cart
const getSessionId = () => {
  let sessionId = localStorage.getItem('yungworld_session_id');
  if (!sessionId) {
    sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('yungworld_session_id', sessionId);
  }
  return sessionId;
};

// Product APIs
export const fetchProducts = async () => {
  const response = await fetch(`${API_URL}/api/products`);
  if (!response.ok) throw new Error('Failed to fetch products');
  return response.json();
};

export const fetchProduct = async (productId) => {
  const response = await fetch(`${API_URL}/api/products/${productId}`);
  if (!response.ok) throw new Error('Failed to fetch product');
  return response.json();
};

// Cart APIs
export const fetchCart = async () => {
  const sessionId = getSessionId();
  const response = await fetch(`${API_URL}/api/cart/${sessionId}`);
  if (!response.ok) throw new Error('Failed to fetch cart');
  return response.json();
};

export const addToCart = async (productId, size, quantity = 1) => {
  const sessionId = getSessionId();
  const response = await fetch(`${API_URL}/api/cart/${sessionId}/add`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ product_id: productId, size, quantity }),
  });
  if (!response.ok) throw new Error('Failed to add to cart');
  return response.json();
};

export const updateCartItem = async (productId, size, quantity) => {
  const sessionId = getSessionId();
  const response = await fetch(`${API_URL}/api/cart/${sessionId}/update`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ product_id: productId, size, quantity }),
  });
  if (!response.ok) throw new Error('Failed to update cart');
  return response.json();
};

export const removeFromCart = async (productId, size) => {
  const sessionId = getSessionId();
  const response = await fetch(`${API_URL}/api/cart/${sessionId}/remove/${productId}/${size}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Failed to remove from cart');
  return response.json();
};

export const clearCart = async () => {
  const sessionId = getSessionId();
  const response = await fetch(`${API_URL}/api/cart/${sessionId}/clear`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Failed to clear cart');
  return response.json();
};

// Order APIs
export const createOrder = async (orderData) => {
  const sessionId = getSessionId();
  const response = await fetch(`${API_URL}/api/orders`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...orderData, session_id: sessionId }),
  });
  if (!response.ok) throw new Error('Failed to create order');
  return response.json();
};

export const fetchOrder = async (orderId) => {
  const response = await fetch(`${API_URL}/api/orders/${orderId}`);
  if (!response.ok) throw new Error('Failed to fetch order');
  return response.json();
};

export { getSessionId };
